import { useQuery } from "@tanstack/react-query"

import { getTraceabilityRequestsQueryParams } from "@tfg/types/schemas/traceabilityRequests"

import { httpClient } from "~/backend/axios"
import { useAuth } from "~/store/auth-context"

export const useGetTraceabilityRequestsClients = ({
  filters,
}: {
  filters: getTraceabilityRequestsQueryParams["filters"]
}) => {
  const { user } = useAuth()
  return useQuery({
    queryKey: ["traceabilityRequestsClients", filters, user?.id],
    queryFn: async () => {
      const res = await httpClient.get<
        {
          id: string
          name: string
        }[]
      >("/traceability-requests/filters/clients", {
        params: { filters },
      })
      return res.data
    },
  })
}
